export const formatUsers = (users) => {
  const {
    id,
    name,
    email,
    phone,
    whatsapp,
    birthday,
    state,
    address,
    city: counties,
    community,
    terms_accepted,
    createdAt,
    lastAcitvity,
    document,
    project,
    projectId,
    event_timestamp
  } = users

  const userObject = {
    id,
    name,
    email,
    phone,
    birthday,
    whatsapp,
    state,
    address,
    counties,
    community,
    terms_accepted,
    createdAt,
    lastAcitvity,
    document,
    event_timestamp
  }

  return userObject
}

const groupFormStepsByKey = (steps, key) => {
  return steps.reduce((acc, step) => {
    const keyValue = step[key];
    if (!acc[keyValue]) {
      acc[keyValue] = [];
    }
    acc[keyValue].push(step);
    return acc;
  }, {});
};

export const groupFormStepsByCategory = (steps) => groupFormStepsByKey(steps, 'category');
export const groupFormStepsByName = (steps) => groupFormStepsByKey(steps, 'name');

const getUniqueSteps = (steps, key) => {
  return steps
    .filter((step, index, self) => self.findIndex(s => s[key] === step[key]) === index)
    .map((step, index) => ({
      value: key === 'id' ? step.id : index,
      label: step[key],
    }));
};

export const getSteps = (steps) => getUniqueSteps(steps, 'category');
export const getFormsSteps = (steps) => getUniqueSteps(steps, 'name');
